import { render, staticRenderFns } from "./LiveModal.vue?vue&type=template&id=36e6639e"
import script from "./LiveModal.vue?vue&type=script&lang=js"
export * from "./LiveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports